import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { Navbar } from 'react-bootstrap';
import TitleLinks from '@bigyellow/components/Shared/TitleLinks';
import { getItem } from '@bigyellow/libs/storage';
import {SIGNOUT} from '@bigyellow/routes';
import PATH from "@bigyellow/routes";

const TopNavbar = ({...props}) => {
    const [state, setState] = useState({
        sideMenu: false,
        isUserLogged : false,
        me: {
            first_name: '',
            last_name: '',
        },
    });
    useEffect(() => {
        getItem('user').then((res) => {
            if (!res) {
                return;
            }

            const { first_name, last_name } = res;

            setState({
                isUserLogged :true,
                me: {
                    first_name: first_name,
                    last_name: last_name,
                },
            });
        });
    }, []);

    const _toggleClass = () => {
        const currentSideMenu = state.sideMenu;
        setState({ sideMenu: !currentSideMenu });
        props.onClick(state.sideMenu);
    };

    return (
        <React.Fragment>
            <Navbar fixed="top" className="top-menu">
                <Navbar.Toggle aria-controls="basic-navbar-nav" />

                <Navbar.Brand
                    href="/"
                    className={`${
                        props.hideLogo ? '' : ''
                    }`}
                >
                    <img
                        src={`${PATH}/assets/img/logo.svg`}
                        alt="BY"
                        className="large-logo"
                        width={105}
                    />
                </Navbar.Brand>

                <div className="container">
                    {props.title && (
                        <div className="col navbar-title">
                            <TitleLinks
                                title={props.title}
                                parent={props.parent}
                                parentLink={props.parentLink}
                            />
                        </div>
                    )}
                </div>

                {/*{state.isUserLogged  &&*/}
                {/*<Link href={SIGNOUT}>*/}
                {/*    <a className="sign-out nav-link">*/}
                {/*        Sign Out*/}
                {/*    </a>*/}
                {/*</Link>*/}
                {/*}*/}

            </Navbar>

            {/* Burger menu */}
            <div
                className={`burger-menu ${state.sideMenu ? 'toggle-menu' : ''}`}
                onClick={_toggleClass}
            >
                <span className="top-bar" />
                <span className="middle-bar" />
                <span className="bottom-bar" />
            </div>
            {/* End Burger menu */}
        </React.Fragment>
    );
}

export default TopNavbar;
